var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V496H496V16Z",
    fill: "#C0392B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M243.958 345.126C194.697 345.126 154.798 305.23 154.798 255.992C154.798 206.806 194.697 166.876 243.958 166.876C268.506 166.876 290.737 176.801 306.816 192.877C286.867 164.327 253.783 145.668 216.366 145.668C155.427 145.668 106 195.06 106 255.992C106 316.966 155.427 366.331 216.366 366.331C253.783 366.331 286.867 347.646 306.816 319.149C290.737 335.162 268.506 345.126 243.958 345.126",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M350.784 208.695L371.362 238.391L406 227.976L384.099 256.756L404.677 286.505L370.568 274.526L348.667 303.303L349.461 267.147L315.352 255.165L349.99 244.851L350.784 208.695",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr);
export default __webpack_public_path__ + "static/media/TR.d8706a2a2cdcc6d8330ee2f8e6bcf20f.svg";
export { ForwardRef as ReactComponent };